import script from "./BInputGroupAppend.vue?vue&type=script&setup=true&lang=js"
export * from "./BInputGroupAppend.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__